<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex h-full w-full items-center justify-center bg-black/50 lg:hidden"
  >
    <div
      v-on-click-outside="closePopup"
      class="relative flex w-[50vw] select-none flex-col items-center rounded-md bg-white p-2 text-center lg:w-96"
    >
      <div
        class="absolute -right-4 -top-4 cursor-pointer rounded-full"
        @click="closePopup"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="black"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="white"
          class="size-8"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </div>

      <RotatePhoneIcon class="w-20" />

      <span
        v-t="'pages.configurator.portrait_popup.text'"
        class="mt-2 text-slate-700"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, Ref } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import RotatePhoneIcon from '@/components/Icons/RotatePhoneIcon.vue';

const show: Ref<boolean> = ref(true);

const checkOrientation = () => {
  show.value = window.matchMedia('(orientation: landscape)').matches;
};

function closePopup(): void {
  show.value = false;
}

onMounted(() => {
  checkOrientation();
  window.addEventListener('resize', checkOrientation);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkOrientation);
});
</script>
